import type { PathObjectInterface } from '@/map-phaser-new/interfaces'

export const boatRightToBottomPath: PathObjectInterface = {
  mainPath: { x: 3849, y: 1417 },
  spline: [
    3722, 1496, 3475, 1590, 3285, 1667, 3069, 1729, 2793, 1801, 2438, 1806, 2227, 1840, 2047, 1940,
    1936, 2029, 1915, 2212,
  ],
}
